"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    emailTemplateConfig: 'Mail mall konfiguration' || 'emailTemplateConfig',
    upsert: '' || 'upsert',
    upsertWhenEmpty: '' || 'upsertWhenEmpty',
    updateWhenEmpty: '' || 'updateWhenEmpty',
    update: '' || 'update',
    id: 'Identitet' || 'id',
    name: 'Namn' || 'name',
    from: 'E-posten som mailet skickas från' || 'from',
    active: 'Aktiverad' || 'active',
    emailHeaderBackgroundImage: 'Bild i mailhuvud' || 'emailHeaderBackgroundImage',
    footerTextHeader: 'Titel i mailfoten' || 'footerTextHeader',
    footerTextBody: 'Text i mailfoten (HTML)' || 'footerTextBody',
    logo: 'Logotype' || 'logo',
    accentColor: 'Accentfärg' || 'accentColor',
    firstButtonText: 'Knapp 1 text' || 'firstButtonText',
    firstButtonLink: 'Knapp 1 länk' || 'firstButtonLink',
    secondButtonText: 'Knapp 2 text' || 'secondButtonText',
    secondButtonLink: 'Knapp 2 länk' || 'secondButtonLink',
    thirdButtonText: 'Knapp 3 text' || 'thirdButtonText',
    thirdButtonLink: 'Knapp 3 länk' || 'thirdButtonLink',
    instagram: 'Instagram Länk' || 'instagram',
    facebook: 'Facebook länk' || 'facebook',
    linkedIn: 'LinkedIn länk' || 'linkedIn',
    owningSupplierOrganizationId: 'owningSupplierOrganizationId' || 'owningSupplierOrganizationId',
    transactionName: 'Transaktionsnamn' || 'transactionName',
    transactionNames: {
        default: 'Standard' || 'default',
        'order-confirmed': 'Order bekräftad' || 'order-confirmed',
    },
    aboutUs: 'Om oss text' || 'aboutUs',
    homePage: 'Hemsida länk' || 'homePage',
    emailFooterImage: 'Bild i mailfot' || 'emailFooterImage',
    contactEmail: 'E-post för frågor' || 'contactEmail',
    companyName: 'Företagsnamn' || 'companyName',
    useOwnSMTPServer: 'Använd egen SMTP-server' || 'useOwnSMTPServer',
    smtpSecure: 'Används TLS/SSL' || 'smtpSecure',
    smtpServer: 'SMTP-server' || 'smtpServer',
    smtpPort: 'SMTP-port' || 'smtpPort',
    smtpUsername: 'SMTP-användarnamn' || 'smtpUsername',
    smtpPassword: 'SMTP-lösenord' || 'smtpPassword',
};
